import * as Types from '../../__generated__/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CompactLinkSearchQueryVariables = Types.Exact<{
  ids?: Types.InputMaybe<Array<Types.Scalars['String']> | Types.Scalars['String']>;
  filter: Array<Types.SearchFilter> | Types.SearchFilter;
  sort: Array<Types.Sort> | Types.Sort;
  first?: Types.InputMaybe<Types.Scalars['Int']>;
}>;


export type CompactLinkSearchQuery = { searchHierarchies: { nodes: { edges: Array<{ node: { id: string, code: string, listName?: string | null } }> } } };


export const CompactLinkSearchDocument = gql`
    query CompactLinkSearch($ids: [String!], $filter: [SearchFilter!]!, $sort: [Sort!]!, $first: Int = 50) {
  searchHierarchies(
    ids: $ids
    filter: $filter
    pagination: {first: $first}
    sort: $sort
  ) {
    nodes {
      edges {
        node {
          id
          code
          listName
        }
      }
    }
  }
}
    `;

/**
 * __useCompactLinkSearchQuery__
 *
 * To run a query within a React component, call `useCompactLinkSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompactLinkSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompactLinkSearchQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useCompactLinkSearchQuery(baseOptions: Apollo.QueryHookOptions<CompactLinkSearchQuery, CompactLinkSearchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompactLinkSearchQuery, CompactLinkSearchQueryVariables>(CompactLinkSearchDocument, options);
      }
export function useCompactLinkSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompactLinkSearchQuery, CompactLinkSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompactLinkSearchQuery, CompactLinkSearchQueryVariables>(CompactLinkSearchDocument, options);
        }
export type CompactLinkSearchQueryHookResult = ReturnType<typeof useCompactLinkSearchQuery>;
export type CompactLinkSearchLazyQueryHookResult = ReturnType<typeof useCompactLinkSearchLazyQuery>;
export type CompactLinkSearchQueryResult = Apollo.QueryResult<CompactLinkSearchQuery, CompactLinkSearchQueryVariables>;